export default {
  // Settings go here
  utilityName: 'Enervee',
  utilityID: null,
  cmsHost: 'https://cms.enervee.com',
  utilityLogo: '',
  waterHeaterLearnMoreLink: '',
  waterHeaterElectricalContractorLink: '',
};
